import * as React from 'react';
var SizeContext = /*#__PURE__*/React.createContext(undefined);
export var SizeContextProvider = function SizeContextProvider(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(SizeContext.Consumer, null, function (originSize) {
    return /*#__PURE__*/React.createElement(SizeContext.Provider, {
      value: size || originSize
    }, children);
  });
};
export default SizeContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/config-provider/SizeContext.js
// module id = 24
// module chunks = 0